<template>
	<div style="padding-left: 20px; padding-right: 20px" v-if="viewLoaded">
		<div v-if="contestConfiguration.emptyApplicationHint">
			<h2 style="margin-left: 20px">Podgląd formularza wniosku</h2>
			<div style="margin-left: 20px; margin-top: 20px; margin-bottom: 20px; white-space: pre-wrap">{{
				contestConfiguration.emptyApplicationHint }}
			</div>
		</div>
		
		<!-- Podstawowe informacje -->
		<!-- <h2 style="margin-left: 20px">Podstawowe informacje</h2> -->
		<agency-application-name-empty
			:readonly="true"
			:contest-name="contestConfiguration.name"
		/>
		<agency-application-english-name-empty
			:readonly="true"
			v-model="projectData.englishTitle"
		/>
		<agency-choose-project-type-empty
			:readonly="true"
			:contest-id="contestData.id"
			v-model="projectData.projectType"
		></agency-choose-project-type-empty>
		<agency-priority-tree-empty
			:readonly="true"
			v-model="projectData.prioritiesData"
			:agency-id="projectData.agencyId"
			:many-accreditation-countries="contestConfiguration.manyAccreditationCountries"
			:many-tasks="contestConfiguration.manyTasks"
			:many-priorities="contestConfiguration.manyPriorities"
			:many-areas="contestConfiguration.manyAreas"
		></agency-priority-tree-empty>

		<!-- Statystyka -->
		<!-- <h2 style="margin-left: 20px">Statystyka</h2> -->
		<agency-choose-funding-empty
			:readonly="false"
			:input="projectData.prioritiesData"
			v-model="projectData.financesData"
			:agency-id="projectData.agencyId"
		></agency-choose-funding-empty>
		<choose-d-a-c-empty
			:readonly="false"
			v-if="contestConfiguration.dacCodesEnabled"
			type="AGENCY_CONTEST"
			:contest-id="contestData.id"
			v-model="projectData.dacCodes"
		></choose-d-a-c-empty>
		<agency-choose-beneficiaries-empty
			:readonly="false"
			v-model="projectData.beneficiariesData"
		></agency-choose-beneficiaries-empty>

		<!-- Działania projektowe -->
		<!-- <h2 style="margin-left: 20px">Działania projektowe</h2> -->
		<agency-choose-actions-empty
			:readonly="false"
			:taken-serial-numbers="projectData.takenSerialNumbers"
			v-model="projectData.actions"
		></agency-choose-actions-empty>
		<agency-activities-table-hint
			v-if="contestConfiguration.activitiesTableHint"
			:hint="contestConfiguration.activitiesTableHint"
		></agency-activities-table-hint>
		<choose-geographical-locations-empty
			:readonly="false"
		></choose-geographical-locations-empty>

		<!-- Koszty -->
		<!-- <h2 style="margin-left: 20px">Koszty</h2> -->
		<agency-actions-costs-empty
			:readonly="false"
			v-model="projectData.costs"
			
			:contest-id="contestData.id"
		></agency-actions-costs-empty>
		<agency-financial-table-hint-empty
			:readonly="true"
			:hint="contestConfiguration.financialTableHint"
		></agency-financial-table-hint-empty>

		<!-- Sekcje generyczne z vue-form-generator -->
		<div v-for="(section, index) in persistentGenericMap" v-bind:key="index">
			<h2 style="margin-left: 20px">{{contestConfiguration.persistentSchema.sections[index].name}}</h2>
			<vue-form-generator
				:disabled="true"
				:name="'persistentGenerator-'.concat(index)"
				:model="section.model"
				:schema="section.schema"
			/>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import {Api} from "@/api";
import {genericFormUtil} from "@/utils/genericFormUtil";
import VueFormGenerator from "vue-form-generator";
import AgencyPriorityTreeEmpty from "./emptyComponents/AgencyPriorityTreeEmpty";
import ChooseDACEmpty from "./emptyComponents/ChooseDACEmpty";
import AgencyChooseFundingEmpty from "./emptyComponents/AgencyChooseFundingEmpty";
import AgencyChooseBeneficiariesEmpty from "./emptyComponents/AgencyChooseBeneficiariesEmpty";
import AgencyChooseProjectTypeEmpty from "./emptyComponents/AgencyChooseProjectTypeEmpty";
import ChooseGeographicalLocationsEmpty from "./emptyComponents/ChooseGeographicalLocationsEmpty";
import AgencyChooseActionsEmpty from "./emptyComponents/AgencyChooseActionsEmpty";
import AgencyActionsCostsEmpty from "./emptyComponents/AgencyActionsCostsEmpty";
import AgencyApplicationNameEmpty from "./emptyComponents/AgencyApplicationNameEmpty";
import AgencyApplicationEnglishNameEmpty from "./emptyComponents/AgencyApplicationEnglishNameEmpty";
import AgencyFinancialTableHintEmpty from "./emptyComponents/AgencyFinancialTableHintEmpty";
import AgencyActivitiesTableHint from "../agencyProject/components/AgencyActivitiesTableHint";

Vue.use(VueFormGenerator);

export default {
	name: "EmptyAgencyApplicationView",
	components: {
		AgencyActivitiesTableHint,
		AgencyFinancialTableHintEmpty,
		AgencyApplicationEnglishNameEmpty,
		AgencyApplicationNameEmpty,
		AgencyActionsCostsEmpty,
		AgencyChooseActionsEmpty,
		ChooseGeographicalLocationsEmpty,
		AgencyChooseProjectTypeEmpty,
		AgencyChooseBeneficiariesEmpty,
		AgencyChooseFundingEmpty,
		ChooseDACEmpty,
		AgencyPriorityTreeEmpty,
	},

	computed: {
		viewLoaded() {
			return this.contestConfigurationLoaded && this.agencyDataLoaded;
		},

		persistentGenericMap() {
			if (this.contestConfiguration.persistentSchema === null || this.projectData.genericModel === null) {
				return null;
			} else {
				let sectionsArray = [];

				for (let i = 0; i < this.contestConfiguration.persistentSchema.sections.length; i++) {
					if (!genericFormUtil.sectionShouldNotBeOnView(this.contestConfiguration.persistentSchema, i)) {
						sectionsArray.push(
							{
								schema: this.applyGenericPersistentForm(i),
								model: this.projectData.genericModel.sections[i].fields,
							},
						);
					}
				}
				return sectionsArray;
			}
		},
	},

	data() {
		return {
			countriesChanged: false,

			contestData: {
				id: this.$route.params.contestId,
			},

			// tutaj pakujemy dane z konfiguracji konkursu
			contestConfiguration: {
				persistentSchema: null,
				manyAccreditationCountries: false,
				manyTasks: false,
				manyAreas: false,
				manyPriorities: false,
				financialTableHint: "",
				activitiesTableHint: "",
				name: "",
				shortName: "",
				dacCodesEnabled: true,
				emptyApplicationHint: null,
			},

			// tutaj pakujemy puste dane projektu dla podglądu
			projectData: {
				genericModel: undefined,
				title: "",
				englishTitle: "",
				projectType: null,
				prioritiesData: {
					extraCountries: [],
					selected: [],
					mainCountryId: null
				},
				financesData: {},
				dacCodes: [],
				beneficiariesData: [],
				actions: [],
				// Przykładowe lokalizacje geograficzne
				locations: [],
				costs: [],
				takenSerialNumbers: [],
				agencyId: null,
			},

			contestConfigurationLoaded: false,
			agencyDataLoaded: false,
		};
	},

	created() {
		this.loadData();
	},

	methods: {
		async loadData() {
			await Api.syncGet(this,
				"/agency-contest/project-configuration"
					+ "?contestId=" + this.contestData.id, successResponse => {
						this.initializeConfiguration(successResponse);
						this.contestConfigurationLoaded = true;
					}, () => {
						this.contestConfigurationLoaded = true;
					});

			// Pobieramy agencyId z endpointu user-agency jak robi to system - tylko dla pracownika placówki
			if (this.roles.isAgencyEmployee()) {
				await Api.syncGet(this,
					"/user/user-agency", successResponse => {
						if (successResponse && successResponse.id) {
							// Symulujemy strukturę danych jak w AgencyProjectView
							this.$set(this.projectData, 'agencyId', successResponse.id);
						}
						this.agencyDataLoaded = true;
					}, () => {
						this.agencyDataLoaded = true;
					});
			} else {
				this.agencyDataLoaded = true;
			}
		},

		changeCountries() {
			this.countriesChanged = true;
		},

		initializeConfiguration(response) {
			this.contestConfiguration.persistentSchema = this.getPersistentSchema(response);
			this.contestConfiguration.manyAccreditationCountries = response.manyAccreditationCountries;
			this.contestConfiguration.manyAreas = response.manyAreas;
			this.contestConfiguration.manyTasks = response.manyTasks;
			this.contestConfiguration.manyPriorities = response.manyPriorities;
			this.contestConfiguration.financialTableHint = response.financialTableHint;
			this.contestConfiguration.activitiesTableHint = response.activitiesTableHint;
			this.contestConfiguration.name = response.name;
			this.contestConfiguration.shortName = response.shortName;
			this.contestConfiguration.dacCodesEnabled = response.dacCodesEnabled;
			this.contestConfiguration.emptyApplicationHint = response.emptyApplicationHint;
			
			// Inicjalizujemy pusty model generyczny dla podglądu
			this.initializeGenericModel();
		},

		getPersistentSchema(response) {
			return genericFormUtil.decodeSchema(response.genericSchema);
		},

		initializeGenericModel() {
			if (this.contestConfiguration.persistentSchema) {
				this.projectData.genericModel = genericFormUtil.buildModelFromSchema(this.contestConfiguration.persistentSchema);
			}
		},

		getSectionModel(index) {
			if (this.projectData.genericModel && this.projectData.genericModel.sections && this.projectData.genericModel.sections[index]) {
				return this.projectData.genericModel.sections[index].fields;
			}
			return {};
		},

		getSectionSchema(index) {
			if (this.contestConfiguration.persistentSchema && this.contestConfiguration.persistentSchema.sections && this.contestConfiguration.persistentSchema.sections[index]) {
				return genericFormUtil.getSectionSchemaFromSchema(this.contestConfiguration.persistentSchema, index, true);
			}
			return {};
		},

		applyGenericPersistentForm(sectionIndex) {
			let sections = this.projectData.genericModel.sections;
			let schema = genericFormUtil.getSectionSchemaFromSchema(this.contestConfiguration.persistentSchema, sectionIndex, true);
			if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
				let schemaValues = sections[sectionIndex].fields;
				return genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
			} else {
				return schema;
			}
		},
	},
};
</script>

<style scoped>
</style>